import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

import { cn } from "~/components/ui/cn";

const statisticsVariants = cva("grid gap-4 rounded border p-6", {
  variants: {
    variant: {
      default: "border-gray-300",
      secondary: "border-beige-400 bg-beige-300",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export function Statistics({
  variant,
  className,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof statisticsVariants>) {
  return (
    <div
      data-slot="statistics"
      className={cn(statisticsVariants({ variant, className }))}
      {...props}
    />
  );
}

const statisticsGroupVariants = cva(
  "grid rounded border p-6 gap-6 [&>div]:border-b [&>div]:pb-6 [&>div:last-child]:pb-0 [&>div]:border-gray-300 [&>div:last-child]:border-none",
  {
    variants: {
      variant: {
        default: "border-gray-300",
        secondary: "border-beige-400 bg-beige-300",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export function StatisticsGroup({
  variant,
  className,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof statisticsGroupVariants>) {
  return (
    <div
      data-slot="statistics-group"
      className={cn(statisticsGroupVariants({ variant, className }))}
      {...props}
    />
  );
}

export function StatisticsGroupStatistics({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="statistics-group-statistics"
      className={cn("grid gap-4", className)}
      {...props}
    />
  );
}

export function StatisticsTitle({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="statistics-title"
      className={cn("flex items-center gap-2.25", className)}
      {...props}
    />
  );
}

export function StatisticsContent({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="statistics-content"
      className={cn("flex", className)}
      {...props}
    />
  );
}
